import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  title: {
    margin: 0,
    paddingTop: '1rem',
    paddingBottom: '1rem',
    fontSize: '2rem',
    fontWeight: 300,
    lineHeight: 1.1,
    color: theme.custom.addColor,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  block: {
    position: 'relative',
    maxWidth: '25rem',
    padding: '2rem 2rem 1rem',
    background: '#fff',
    borderRadius: 2,
    boxShadow: '0 3px 15px -1px rgba(0,0,0,.5)',
  },
  closeIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    color: theme.custom.mainColor,
    cursor: 'pointer',
  },
  description: {
    fontSize: '1.2rem',
    color: '#666',
  },
}));
